/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios'

export default {
  API: {
    MOCK_API_LIST: '/settings/mockApiList',
    MOCK_API_DATA: '/settings/mockApiData',
    MOCK_API_DATA_UPDATE: '/settings/mockApiDataUpdate',
    PROCESS_LIST: '/settings/processList',
    FILE_VIEW: '/file/view',
  },

  cancelTokens: [],

  getRequest(authUser, url, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      return axios.get(url, {headers: headers, timeout: 300000});
    }
    else {
      return null;
    }
  },

  postRequest(authUser, url, payload, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      let cancelTokenKey = url;
      if(this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token
      }

      return axios.post(url, payload, options);
    }
    else {
      return null;
    }
  },

  async fetchMockApiList(authUser) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.MOCK_API_LIST;
    return this.getRequest(authUser, url);
  },

  async fetchMockApiData(authUser, apiPath) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.MOCK_API_DATA;
    return this.postRequest(authUser, url, {api: apiPath});
  },

  async updateMockApiData(authUser, data) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.MOCK_API_DATA_UPDATE;
    return this.postRequest(authUser, url, data);
  },

  async fetchProcessList(authUser, data) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.PROCESS_LIST;
    return this.postRequest(authUser, url, data);
  },

  async fetchFileContent(authUser, data) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.FILE_VIEW;

    let headers = {};
    headers["Content-Type"] = "application/json";
    headers["Authorization"] = "Bearer " + authUser.accessToken;
    headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);
    if(authUser.sessionId) {
      headers['Auth-Host'] = authUser.authHost || "";
      headers['Auth-Session-Id'] = authUser.sessionId;
      headers['Auth-Product-Name'] = authUser.productName || "";
      headers['Auth-Options'] = authUser.authOptions || "";
    }
    
    return await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data)
    });
  },
}